import { useState, useEffect } from 'react';
import {
  Badge,
  Box,
  IconButton,
  Popover,
  Typography,
  Divider,
  List,
  ListItemText,
  ListItem,
  ListItemIcon,
} from '@mui/material';
import { IconBell, IconWand } from '@tabler/icons-react';
import { map, orderBy } from 'lodash';
import { onSnapshot, query, where } from 'firebase/firestore';
import moment from 'moment';
import Update from '../../../../models/update';
import UpdateDb from '../../../../db/updateDb';
import { useUsuario } from '../../../../providers/usuarioProvider';

export default function NotificacoesAppBar() {
  const { claims } = useUsuario();
  const [updates, setUpdates] = useState<Update[]>([]);
  const [anchorEl, setAnchorEl] = useState<HTMLButtonElement | null>(null);

  useEffect(() => {
    if (!!claims?.perfil) {
      return onSnapshot(
        query(
          new UpdateDb().collection({ updateId: '' }),
          where('perfil', 'array-contains', claims.perfil),
        ),
        (querySnapshot) => {
          const allUpdates = orderBy(
            map(querySnapshot.docs, (doc) => doc.data()),
            'dataUpdate',
            'desc',
          );
          // Mostrar novidades dos últimos 60 dias, mas sempre incluir pelo menos a última
          const recentUpdates = allUpdates.filter((update) =>
            update.dataUpdate.isAfter(moment().subtract(60, 'days')),
          );
          setUpdates(
            recentUpdates.length > 0 ? recentUpdates : allUpdates.slice(0, 1),
          );
        },
      );
    }
  }, [claims?.perfil]);

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);

  return (
    <Box>
      <IconButton color="inherit" onClick={handleClick}>
        {/* "novidade" mapeia para o semântico accent (processando/novo), mas na
            TINTA (`info` = accent-ink no tema): o dot em `primary.main` dá
            2,57:1 sobre a barra escura e some. */}
        <Badge badgeContent={updates.length} color="info" variant="dot">
          <IconBell size={20} />
        </Badge>
      </IconButton>
      <Popover
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'right',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
        PaperProps={{
          sx: { width: '40vw', maxWidth: 420, maxHeight: 360 },
        }}
      >
        <Box px={2} pt={2} pb={1.5}>
          <Typography variant="eyebrow" color="text.secondary">
            Novidades
          </Typography>
        </Box>
        <Divider />
        <List sx={{ pt: 0 }}>
          {updates.length === 0 ? (
            <ListItem>
              <ListItemText secondary="Nenhuma novidade no momento." />
            </ListItem>
          ) : (
            map(updates, (update, index) => (
              <ListItem
                key={index}
                alignItems="flex-start"
                divider={index < updates.length - 1}
              >
                <ListItemIcon
                  sx={{ minWidth: 32, mt: 0.5, color: 'text.secondary' }}
                >
                  <IconWand size={16} />
                </ListItemIcon>
                <ListItemText
                  primary={
                    // Data é dado: mono tabular para alinhar entre linhas.
                    <Typography variant="labelMono" color="text.secondary">
                      {update.dataUpdate.format('DD/MM')}
                    </Typography>
                  }
                  secondary={
                    <Typography variant="body2" color="text.primary">
                      {update.mensagem}
                    </Typography>
                  }
                />
              </ListItem>
            ))
          )}
        </List>
      </Popover>
    </Box>
  );
}
